import { CSSProperties, ReactNode } from 'react';
import { DatePicker as BaseDatePicker, DayModifiers } from '@mantine/dates';
import { useIntlLight } from '../../../i18n';

export default function DatePicker({
  className,
  name,
  label,
  placeholder,
  required,
  inputFormat,
  error,
  value,
  onChange,
  minDate,
  icon,
  dayStyle,
  renderDay,
}: {
  className?: string;
  name?: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
  inputFormat?: string;
  error?: any;
  value?: Date | null;
  onChange?: ((value: Date | null) => void) | undefined;
  minDate?: Date;
  icon?: ReactNode;
  dayStyle?: (date: Date, modifiers: DayModifiers) => CSSProperties;
  renderDay?: (date: Date) => ReactNode;
}) {
  const { t } = useIntlLight();
  return (
    <BaseDatePicker
      className={className}
      name={name}
      label={label ?? t('app.selectDate')}
      placeholder={placeholder ?? t('app.selectDate')}
      required={required}
      inputFormat={inputFormat}
      error={error?.message}
      value={value}
      onChange={onChange}
      minDate={minDate}
      icon={icon}
      dayStyle={dayStyle}
      renderDay={renderDay}
    />
  );
}
